import React, { Component } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import copy from 'copy-to-clipboard';

import '../style/BuyBox.css'

const ADDRESS = "addr1vxjykr8rtk50jymkw60t49j7n8rju557c3r07kxy3w0nvts8n26f3";

export class Buy extends Component {

    constructor(props) {
        super();
        this.state = {
            canBuy: true,
            isReserved: false,
            isLoading: true,
            buyData: undefined,
            isError: false,
            isDone: false
        }
        this.reservedBox = this.reservedBox.bind(this);
        this.loadingBox = this.loadingBox.bind(this);
        this.buyBox = this.buyBox.bind(this);
        this.soldOutBox = this.soldOutBox.bind(this);
        this.isDoneBox = this.isDoneBox.bind(this);
        this.markDone = this.markDone.bind(this);
    }

    notify(msg) {
        toast(msg);
    }

    markDone() {
        this.setState({
            isDone: true
        }, () => {

        })
    }

    componentDidMount() {
        // const API_KEY = 'NFROGTS_API_KEY_000';
        // const BASE_URL = 'https://encoded-obelisk-310514.uc.r.appspot.com';
        // fetch(`${BASE_URL}/getFreeFrog`, { headers: { 'API_KEY': API_KEY } }).then(res => res.json()).then(data => {
        //     if (data.sold_frogs >= 1500) {
        //         this.setState({
        //             canBuy: false,
        //             isReserved: false,
        //             isLoading: false,
        //             buyData: undefined
        //         })
        //     }
        //     else {
        //         if (data.amount) {
        //             // const buyData = new BuyData(data.amountł, data.frog_id)
        //             this.setState({
        //                 canBuy: true,
        //                 isReserved: false,
        //                 isLoading: false,
        //                 buyData: data
        //             }, () => {
        //                 fetch(`${BASE_URL}/reserveFrog`, { method: 'POST', body: JSON.stringify(data) ,headers: { 'API_KEY': API_KEY, 'Content-Type': 'application/json', } })
        //                 .then(res => res.json())
        //                 .then(reserveData => {
        //                     if(reserveData.msg !== `Frog ${data.frog_id} reserved`){
        //                         this.setState({
        //                             canBuy: false,
        //                             isReserved: false,
        //                             isLoading: false,
        //                             buyData: undefined,
        //                             isError:true
        //                         })
        //                     }
        //                 })
        //             });

        //         }
        //         else if (data.msg === "All frogs reserved") {
        //             this.setState({
        //                 canBuy: false,
        //                 isReserved: true,
        //                 isLoading: false,
        //                 buyData: undefined
        //             })
        //         }
        //         else {
        //             this.setState({
        //                 canBuy: false,
        //                 isReserved: false,
        //                 isLoading: false,
        //                 buyData: undefined
        //             })
        //         }
        //     }

        // })
    }

    reservedBox() {
        return (
            <div id="buyBox">
                <h1>Currently all frogs are reserved</h1>
                <h1>If any of frog is free, information will change</h1>

            </div>
        )
    }

    loadingBox() {
        return (
            <div id="buyBox">
                <span>Loading...</span>
            </div>
        )
    }

    errorBox() {
        return (
            <div id="buyBox">
                <h1>Somebody already reserved this frog...</h1>
                <h1>Please refresh the website</h1>
            </div>
        )
    }

    soldOutBox() {
        return (
            <div id="buyBox">
                <h1>All NFROGTS have been sold!</h1>
            </div>
        )
    }

    isDoneBox() {
        return (
            <div id="buyBox">
                <span>Thanks for Your purschase! You will receive frog in a few minutes! To buy next frog, refresh the website!</span>
            </div>
        )
    }

    componentWillUnmount() {

        // this.unsubscribe();
    }

    copy(text) {
        const textArea = document.createElement('textarea')
        document.body.appendChild(textArea);
        textArea.value = text;
        textArea.select()
        document.execCommand("Copy");
        textArea.remove();
    }

    buyBox() {
        return (
            <div id="buyBox">



                <div className="buy-box-bar">
                    <div className="buy-box-subbar">
                        <span className="buy-box-bar-span">SOLD: </span>

                        <span className="buy-box-bar-span" className="amount-span"> {this.state.buyData ? this.state.buyData.sold_frogs : "-"}/1500</span>
                    </div>
                </div>

                <div className="buy-box-bar">
                    <div className="buy-box-subbar">
                        <i className='fas fa-copy buy-box-subbar-icon' onClick={() => this.copy(this.state.buyData.amount)}></i> <span className="buy-box-bar-span">ADA: </span>

                        <span className="buy-box-bar-span" id="amountSpan"> {this.state.buyData ? this.state.buyData.amount : "-"}</span>
                    </div>
                </div>

                <div className="buy-box-bar">
                    <div className="buy-box-subbar">
                        <i className='fas fa-copy buy-box-subbar-icon' onClick={() => this.copy(ADDRESS)}></i>
                        <span className="buy-box-bar-span">ADDRESS: </span>
                    </div>
                    <span id="addressSpan"
                        className="buy-box-bar-span">{ADDRESS}</span>
                </div>

                <button id="doneBtn" onClick={this.markDone}>DONE</button>
            </div>
        )
    }

    render() {

        return (
            <div id="buyBox">Sale is over</div>
        )

    }
}

export default Buy
